import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzResultModule } from 'ng-zorro-antd/result';

import { CatalogClient, CartClient } from '@medindex-webapi';
import { BacktopComponent } from '@shared/components/backtop/backtop.component';
import { MobileFiltersModalModule } from '@shared/modules/mobile-filters-modal/mobile-filters-modal.module';
import { FloatingButtonComponent } from '@shared/components/floating-button/floating-button.component';
import { PreventDoubleclickDirective } from '@shared/directives/prevent-doubleclick.directive';
import { ItemSkeletonComponent } from '@shared/components/item-skeleton/item-skeleton.component';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { TestSystemsModule } from '@shared/components/test-systems/test-systems.module';
import { SharedModule } from '@shared/shared.module';
import { BreadcrumbModule } from '@shared/modules/breadcrumb/breadcrumb.module';
import { SkeletonModule } from '@shared/modules/skeleton/skeleton.module';
import { FormatTitleModule } from '@shared/pipes/format-title/format-title.module';
import { SStrikeColorDirective } from '@shared/directives/s.strike-color.directive';

import { CatalogRoutingModule } from './catalog-routing.module';
import { PageheaderComponent } from './components/pageheader/pageheader.component';
import { PriceComponent } from './components/price/price.component';
import { DescriptionComponent } from './components/description/description.component';
import { KbButtonComponent } from './components/kb-button/kb-button.component';
import { ExampleFileButtonComponent } from './components/example-file-button/example-file-button.component';
import { ShortDescriptionComponent } from './components/short-description/short-description.component';
import { HelixExpressAdComponent } from './components/helix-express-ad/helix-express-ad.component';
import { CategorySelectionModalComponent } from './components/category-selection-modal/category-selection-modal.component';
import { ServiceInDiagnosticCenterComponent } from './components/service-in-diagnostic-center/service-in-diagnostic-center.component';
import { PreparationsComponent } from './components/preparations/preparations.component';
import { ComplexPartsComponent } from './components/complex-parts/complex-parts.component';
import { IndicationsTabComponent } from './components/indications-tab/indications-tab.component';
import { SectionListComponent } from './components/section-list/section-list.component';
import { ListSkeletonComponent } from './components/list-skeleton/list-skeleton.component';
import { DetailedInfoComponent } from './components/detailed-info/detailed-info.component';
import { FiltersComponent } from './components/filters/filters.component';
import { CatalogSiderComponent } from './components/catalog-sider/catalog-sider.component';
import { ButtonResetFiltersComponent } from './components/button-reset-filters/button-reset-filters.component';
import { MobileFiltersModalCatalogComponent } from './components/mobile-filters-modal-catalog/mobile-filters-modal-catalog.component';
import { HelixLiteInfoComponent } from './components/helix-lite-info/helix-lite-info.component';

@NgModule({
  imports: [
    HelixLiteInfoComponent,
    CatalogRoutingModule,
    BreadcrumbModule,
    SkeletonModule,
    CommonModule,
    FormsModule,
    NzSelectModule,
    NzTabsModule,
    NzCollapseModule,
    NzModalModule,
    NzPopoverModule,
    NzSkeletonModule,
    NzResultModule,
    TestSystemsModule,
    SharedModule,
    BacktopComponent,
    FormatTitleModule,
    MobileFiltersModalModule,
    FloatingButtonComponent,
    PreventDoubleclickDirective,
    PaginationComponent,
    SectionListComponent,
    ItemSkeletonComponent,
    DetailedInfoComponent,
    FiltersComponent,
    SafeHtmlPipe,
    CatalogSiderComponent,
    ButtonResetFiltersComponent,
    SStrikeColorDirective,
  ],
  declarations: [
    CatalogRoutingModule.components,
    KbButtonComponent,
    PageheaderComponent,
    PriceComponent,
    DescriptionComponent,
    ExampleFileButtonComponent,
    ShortDescriptionComponent,
    HelixExpressAdComponent,
    CategorySelectionModalComponent,
    ServiceInDiagnosticCenterComponent,
    ListSkeletonComponent,
    PreparationsComponent,
    ComplexPartsComponent,
    IndicationsTabComponent,
    MobileFiltersModalCatalogComponent,
  ],
  providers: [CatalogClient, CartClient],
})
export class CatalogModule {}
